import { RefinanceCalculator } from "../Apps/RefinanceCalculator"

function AppRefinanceCalculator() {

  return (
    <RefinanceCalculator />
  )
}

export default AppRefinanceCalculator